import { Record } from "immutable"

export const schema = {
  id: undefined,
  name: "",
}

export default Record(schema)



// WEBPACK FOOTER //
// ./src/models/game.model.js